"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITE_TYPE = void 0;
exports.SITE_TYPE = {
    LANDING: 'LANDING',
    TEMPLATE: 'TEMPLATE'
};
//# sourceMappingURL=siteType.js.map